// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-button-sv {
  width: 15px;
  margin-left: 5px;
}
.tabs {
  padding-left: 20px;
  color: white;
  padding-right: 20px;
}
.table>:not(caption)>*>*  {
  padding: .5rem .5rem;
  color:white;
  /* color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color))); */
  background-color: rgba(59, 65, 102, 1) !important;
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure it's above other content */
}




.tabs button {
  background: transparent;
  border: none;
  color: white;
  outline: none;
  cursor: pointer;
  padding: 10px 20px;
  margin-right: 10px;
  font-size: 16px;
  
}


.tab-content .box {
  width: calc(33.33% - 10px); 
  height: 100px; 
  background-color: #ccc;
  margin-right: 10px;
  margin-bottom: 10px;
} 

@media (max-width: 768px) {
  .tab-content .box {
    width: calc(50% - 10px); 
  }
}

.tabs button.active {
  border-bottom: 2px solid white;
}



.status-dd-sv {
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #8d97dac5;
  height: 30px;
  width: 93px;
  background-color: transparent;
  margin-right: 10px;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
  padding-left: 5px;
}

.status-dd-sv::placeholder {
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
  padding: 10px 5px;
  margin-top: 17px;
}

.status-dd-sv:focus {
  outline: none;
  /* margin-top: 17px; */
}

.status-dd-sv option {
  color: white;
  background-color: #3C4069;
  border: 1px solid #747BA9;
  font-size: 12px;
  font-family: Graphik;
  font-weight: 400;
  margin-top: 17px;
}

.icon12-sv {
  position: absolute;
  top: 45%;
  transform: translateY(-45%);
}

.icon-input-sv {
  position: relative;
}

.icon-input-sv input {
  padding-left: 25px;
}

.icon12-sv {
  position: absolute;
  left: 15px;
  top: 45%;
  transform: translateY(-50%);
}

.datepicker-sv {
  padding-left: 20px;
}

/* .player-sv{
    margin: 0px 0px 0px 35px;
  } */
/* .player-size-sv{    
    width: 45vw !important;
    height: 0vh !important;
  } */
.stack-sv {
 
  width: 34vw;
  border: 1px solid #8d97dac5;
  border-radius: 15px;
  /* width: 25vw; */
}

.video-react .video-react-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-react.video-react-fluid,
.video-react.video-react-16-9,
.video-react.video-react-4-3 {
  width: 90%;
  max-width: 90%;
  height: 0%;
}

.video-react {
  display: block;
  /* vertical-align: top; */
  box-sizing: border-box;
  color: #fff;
  background-color: transparent;
  position: relative;
  font-size: 10px;
  line-height: 1;
  font-family: serif, Times, "Times New Roman";
  -webkit-user-select: none;
  user-select: none;
}

.always-visible-control-bar {
  opacity: 1 !important;
}

.videoList-sv {
  cursor: pointer;
  display: flex;
  margin-left: "20px";
  padding-top: "5px";
  /* border-radius: 10px; */
  margin-bottom: 5px;
  border-bottom: 1px solid #8d97dac5;
  /* border-radius: 15px; */
}

.videoList-sv:hover {
  background-color: #2F528F;
}

.metadataList-sv {
  cursor: pointer;
  display: flex;
  margin-left: "20px";
  padding-top: "5px";
  /* border-radius: 10px; */
  /* margin-bottom: 5px; */
  /* border-bottom: 1px solid #8d97dac5; */
  /* border-radius: 15px; */
}

/* .metadataList-sv:hover {
  background-color: #2F528F; 
} */

.close-icon-sv {
  font-size: 24px;
  position: absolute;
  cursor: pointer;
  color: blueviolet;
  background-color: transparent;
  border: none;
  border-radius: 5px;
  width: 22px;
  margin-left: 430px;
}

.container-row-mail-sv {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-family: Graphik;
  padding-top: 10px;
  color: white;
}

.modal-sv-mail {
  background-color: rgba(30, 32, 61, 1);
  border: 1px solid #6B5CD1;
  border-radius: 15px;
  overflow-y: auto;
  /* margin-top: 50px; */
  /* height:100%;
  width: 100%; */
  height: 90%;
  width: 50%;
}

.modal-mail-sv {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  top: 0;
  left: 0;
}

.container-data-mail-sv {
  background-color: #25304C;
  /* width: 43vw; */
  height: 45vh;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #8d97dac5;
  text-align: left;
  padding: 5px;
  color: white
}

.mail-content-sv {
  padding: 10px 20px;
}

.sv-mail-icon {
  width: 25px;
}

.sv-pdf-icon {
  width: 20px;
  margin-right: 5px;
}

.sv-send-icon {
  width: 20px;
  margin-left: 5px;
}

.processe-sv-button {
  border-radius: 15px;
  margin-left: 240px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  text-decoration: none;
  font-size: 15px;
  width: fit-content;
  height: fit-content;
  border-style: solid;
  float: right;
  margin: 20px 10px 20px 0px;
  padding: 5px 10px;
  border: none;
  display: flex;
  align-items: center;
}

.analysis-head-sv {
  color: #FFFFFF;
  font-family: 'Graphik';
  font-weight: 500;
  font-size: 14px;
  margin-top: 10px;
  padding: 10px;
  margin-left: 10px;
  position: relative;
}

.analysis-backdrop-sv {
  background-color: rgba(39, 40, 75, 1);
  margin-top: -10px;
  border-radius: 10px;
}

.video-react .video-react-big-play-button {
  display: none;
}

.metadata-text-sv {
  font-size: 12px;
  font-family: "Graphik";
  font-weight: 355;
  color: #FFFFFF;
  line-height: 14px;
}

.metadata-heading-sv {
  font-size: 16px;
  font-family: "Graphik";
  font-weight: 500;
  /* border-bottom: 1px solid rgb(6, 214, 160); */
  line-height: 14px;
  color: #FFFFFF
}

.metadata-key-sv {
  color: rgb(107, 92, 209);
}

.metadata-key-sv1 {
  color: aliceblue
}

.status-sv {
  max-width: fit-content;
  margin-top: -6px;
  padding: 1% 3%;
  height: fit-content;
  /* background-color: rgba(36, 182, 0, 1); */
  /* rgba(216, 172, 27, 1) */
  color: rgba(255, 255, 255, 1);
  font-family: Graphik;
  font-size: 11px;
  font-weight: 300;
  border: none;
  border-radius: 8dvh;
}

.novideo-sv {
  color: white;
  margin-top: 33vh;
  margin-left: 23vw;
  font-size: 15px;
  font-family: Graphik;
  font-weight: 355;
}

.sv-pdf-icon {
  width: 20px;
}

.sv-send-icon {
  width: 18px;
  margin-left: 5px;
}


.loader-sv {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  margin-top: 30px;
}

.dot-cq-sv {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out;
  margin-left: 10px;
  margin-bottom: 30px;
  will-change: transform;
}

.red-c-sv {
  background-color: #5858FF;
  animation-delay: -0.32s;
}

.green-c-sv {
  background-color: #00ADEB;
  animation-delay: -0.16s;
}

.blue-c-sv {
  background-color: #00F2C2;

}

.mail-close-sv {
  width: 10px;
  margin-left: 5px;
}

.mail-image-sv {
  width: "fit-content";
  border: 1px solid #8d97dac5;
  border-radius: 5px;
  background-color: #3C4069;
  color: #FFFFFF;
  font-size: 10px;
  font-family: Graphik;
}

.container-data-webcam-sv {
  background-color: #25304C;
  width: 180px;
  height: 30px;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #8d97dac5;
  text-align: left;
  padding: 5px;
  color: white;  
  position:absolute;
  left: 4%;
  top: 73%;
}`, "",{"version":3,"sources":["webpack://./src/Safety_Vigilance/SafetyVigilance.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,2FAA2F;EAC3F,iDAAiD;EACjD,2CAA2C;EAC3C,2GAA2G;AAC7G;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,sCAAsC;EAC5E,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,oCAAoC;AACrD;;;;;AAKA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;;AAEjB;;;AAGA;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,8BAA8B;AAChC;;;;AAIA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;KAEK;AACL;;;KAGK;AACL;;EAEE,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,UAAU;EACV,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,4CAA4C;EAC5C,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB;gBACc;EACd,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,MAAM;EACN,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,+CAA+C;EAC/C,iBAAiB;EACjB;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,0BAA0B;EAC1B,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;;AAE3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,QAAQ;AACV","sourcesContent":[".filter-button-sv {\n  width: 15px;\n  margin-left: 5px;\n}\n.tabs {\n  padding-left: 20px;\n  color: white;\n  padding-right: 20px;\n}\n.table>:not(caption)>*>*  {\n  padding: .5rem .5rem;\n  color:white;\n  /* color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color))); */\n  background-color: rgba(59, 65, 102, 1) !important;\n  border-bottom-width: var(--bs-border-width);\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.loader-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999; /* Ensure it's above other content */\n}\n\n\n\n\n.tabs button {\n  background: transparent;\n  border: none;\n  color: white;\n  outline: none;\n  cursor: pointer;\n  padding: 10px 20px;\n  margin-right: 10px;\n  font-size: 16px;\n  \n}\n\n\n.tab-content .box {\n  width: calc(33.33% - 10px); \n  height: 100px; \n  background-color: #ccc;\n  margin-right: 10px;\n  margin-bottom: 10px;\n} \n\n@media (max-width: 768px) {\n  .tab-content .box {\n    width: calc(50% - 10px); \n  }\n}\n\n.tabs button.active {\n  border-bottom: 2px solid white;\n}\n\n\n\n.status-dd-sv {\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  border-color: #8d97dac5;\n  height: 30px;\n  width: 93px;\n  background-color: transparent;\n  margin-right: 10px;\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 400;\n  padding-left: 5px;\n}\n\n.status-dd-sv::placeholder {\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 400;\n  padding: 10px 5px;\n  margin-top: 17px;\n}\n\n.status-dd-sv:focus {\n  outline: none;\n  /* margin-top: 17px; */\n}\n\n.status-dd-sv option {\n  color: white;\n  background-color: #3C4069;\n  border: 1px solid #747BA9;\n  font-size: 12px;\n  font-family: Graphik;\n  font-weight: 400;\n  margin-top: 17px;\n}\n\n.icon12-sv {\n  position: absolute;\n  top: 45%;\n  transform: translateY(-45%);\n}\n\n.icon-input-sv {\n  position: relative;\n}\n\n.icon-input-sv input {\n  padding-left: 25px;\n}\n\n.icon12-sv {\n  position: absolute;\n  left: 15px;\n  top: 45%;\n  transform: translateY(-50%);\n}\n\n.datepicker-sv {\n  padding-left: 20px;\n}\n\n/* .player-sv{\n    margin: 0px 0px 0px 35px;\n  } */\n/* .player-size-sv{    \n    width: 45vw !important;\n    height: 0vh !important;\n  } */\n.stack-sv {\n \n  width: 34vw;\n  border: 1px solid #8d97dac5;\n  border-radius: 15px;\n  /* width: 25vw; */\n}\n\n.video-react .video-react-video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.video-react.video-react-fluid,\n.video-react.video-react-16-9,\n.video-react.video-react-4-3 {\n  width: 90%;\n  max-width: 90%;\n  height: 0%;\n}\n\n.video-react {\n  display: block;\n  /* vertical-align: top; */\n  box-sizing: border-box;\n  color: #fff;\n  background-color: transparent;\n  position: relative;\n  font-size: 10px;\n  line-height: 1;\n  font-family: serif, Times, \"Times New Roman\";\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.always-visible-control-bar {\n  opacity: 1 !important;\n}\n\n.videoList-sv {\n  cursor: pointer;\n  display: flex;\n  margin-left: \"20px\";\n  padding-top: \"5px\";\n  /* border-radius: 10px; */\n  margin-bottom: 5px;\n  border-bottom: 1px solid #8d97dac5;\n  /* border-radius: 15px; */\n}\n\n.videoList-sv:hover {\n  background-color: #2F528F;\n}\n\n.metadataList-sv {\n  cursor: pointer;\n  display: flex;\n  margin-left: \"20px\";\n  padding-top: \"5px\";\n  /* border-radius: 10px; */\n  /* margin-bottom: 5px; */\n  /* border-bottom: 1px solid #8d97dac5; */\n  /* border-radius: 15px; */\n}\n\n/* .metadataList-sv:hover {\n  background-color: #2F528F; \n} */\n\n.close-icon-sv {\n  font-size: 24px;\n  position: absolute;\n  cursor: pointer;\n  color: blueviolet;\n  background-color: transparent;\n  border: none;\n  border-radius: 5px;\n  width: 22px;\n  margin-left: 430px;\n}\n\n.container-row-mail-sv {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  font-family: Graphik;\n  padding-top: 10px;\n  color: white;\n}\n\n.modal-sv-mail {\n  background-color: rgba(30, 32, 61, 1);\n  border: 1px solid #6B5CD1;\n  border-radius: 15px;\n  overflow-y: auto;\n  /* margin-top: 50px; */\n  /* height:100%;\n  width: 100%; */\n  height: 90%;\n  width: 50%;\n}\n\n.modal-mail-sv {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 10000;\n  top: 0;\n  left: 0;\n}\n\n.container-data-mail-sv {\n  background-color: #25304C;\n  /* width: 43vw; */\n  height: 45vh;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  border-color: #8d97dac5;\n  text-align: left;\n  padding: 5px;\n  color: white\n}\n\n.mail-content-sv {\n  padding: 10px 20px;\n}\n\n.sv-mail-icon {\n  width: 25px;\n}\n\n.sv-pdf-icon {\n  width: 20px;\n  margin-right: 5px;\n}\n\n.sv-send-icon {\n  width: 20px;\n  margin-left: 5px;\n}\n\n.processe-sv-button {\n  border-radius: 15px;\n  margin-left: 240px;\n  color: rgba(255, 255, 255, 1);\n  text-align: center;\n  text-decoration: none;\n  font-size: 15px;\n  width: fit-content;\n  height: fit-content;\n  border-style: solid;\n  float: right;\n  margin: 20px 10px 20px 0px;\n  padding: 5px 10px;\n  border: none;\n  display: flex;\n  align-items: center;\n}\n\n.analysis-head-sv {\n  color: #FFFFFF;\n  font-family: 'Graphik';\n  font-weight: 500;\n  font-size: 14px;\n  margin-top: 10px;\n  padding: 10px;\n  margin-left: 10px;\n  position: relative;\n}\n\n.analysis-backdrop-sv {\n  background-color: rgba(39, 40, 75, 1);\n  margin-top: -10px;\n  border-radius: 10px;\n}\n\n.video-react .video-react-big-play-button {\n  display: none;\n}\n\n.metadata-text-sv {\n  font-size: 12px;\n  font-family: \"Graphik\";\n  font-weight: 355;\n  color: #FFFFFF;\n  line-height: 14px;\n}\n\n.metadata-heading-sv {\n  font-size: 16px;\n  font-family: \"Graphik\";\n  font-weight: 500;\n  /* border-bottom: 1px solid rgb(6, 214, 160); */\n  line-height: 14px;\n  color: #FFFFFF\n}\n\n.metadata-key-sv {\n  color: rgb(107, 92, 209);\n}\n\n.metadata-key-sv1 {\n  color: aliceblue\n}\n\n.status-sv {\n  max-width: fit-content;\n  margin-top: -6px;\n  padding: 1% 3%;\n  height: fit-content;\n  /* background-color: rgba(36, 182, 0, 1); */\n  /* rgba(216, 172, 27, 1) */\n  color: rgba(255, 255, 255, 1);\n  font-family: Graphik;\n  font-size: 11px;\n  font-weight: 300;\n  border: none;\n  border-radius: 8dvh;\n}\n\n.novideo-sv {\n  color: white;\n  margin-top: 33vh;\n  margin-left: 23vw;\n  font-size: 15px;\n  font-family: Graphik;\n  font-weight: 355;\n}\n\n.sv-pdf-icon {\n  width: 20px;\n}\n\n.sv-send-icon {\n  width: 18px;\n  margin-left: 5px;\n}\n\n\n.loader-sv {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  margin-top: 30px;\n}\n\n.dot-cq-sv {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounce 1.4s infinite ease-in-out;\n  margin-left: 10px;\n  margin-bottom: 30px;\n  will-change: transform;\n}\n\n.red-c-sv {\n  background-color: #5858FF;\n  animation-delay: -0.32s;\n}\n\n.green-c-sv {\n  background-color: #00ADEB;\n  animation-delay: -0.16s;\n}\n\n.blue-c-sv {\n  background-color: #00F2C2;\n\n}\n\n.mail-close-sv {\n  width: 10px;\n  margin-left: 5px;\n}\n\n.mail-image-sv {\n  width: \"fit-content\";\n  border: 1px solid #8d97dac5;\n  border-radius: 5px;\n  background-color: #3C4069;\n  color: #FFFFFF;\n  font-size: 10px;\n  font-family: Graphik;\n}\n\n.container-data-webcam-sv {\n  background-color: #25304C;\n  width: 180px;\n  height: 30px;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  border-color: #8d97dac5;\n  text-align: left;\n  padding: 5px;\n  color: white;  \n  position:absolute;\n  left: 4%;\n  top: 73%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
